module.exports = new __parcel__URL__("bp_space_elixir_icon.bb1010ad.png").toString();